module.exports = __webpack_public_path__ + "img/pagsmile-color.c0a57a6.svg";